<template>
    <header class="fixed pin-t pin-r block p-3 bg-white shadow-md z-10" style="left: 250px; height: 60px;">
        <div class="flex items-center w-full">
            <div>
                <app-locales />
            </div>
            <div class="ml-auto">
                <app-information :opened="opened.information" @open="open" />
            </div>
        </div>
    </header>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Logout from '@/components/Logout';
    import Information from '@/components/template/Information';
    import Locales from '@/components/template/Locales';

    export default {
        name: 'app-header',
        components: {
            'app-logout': Logout,
            'app-information': Information,
            'app-locales': Locales
        },
        data: () => ({
            opened: {
                search: false,
                notifications: false,
                information: false,
                activity: false
            },
        }),

        methods: {
            open(value) {
                if(typeof this.opened[value] !== 'undefined') {
                    for(let key in this.opened) {
                        if(key !== value) this.opened[key] = false;
                    }
                    this.opened[value] = !this.opened[value];
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/template/Header.vue